import { createStore } from '@xstate/store';
import { useSelector } from '@xstate/store/react';

export const preventAutoReloadStore = createStore(
  { preventReasons: new Set<string>() },
  {
    addReason: (
      ctx: { preventReasons: Set<string> },
      event: { reason: string },
    ) => ({
      preventReasons: new Set(ctx.preventReasons).add(event.reason),
    }),
    removeReason: (
      ctx: { preventReasons: Set<string> },
      event: { reason: string },
    ) => {
      const next = new Set(ctx.preventReasons);
      next.delete(event.reason);
      return { preventReasons: next };
    },
    reset: () => ({
      preventReasons: new Set<string>(),
    }),
  },
);

export const shouldPreventAutoReload = () =>
  preventAutoReloadStore.getSnapshot().context.preventReasons.size > 0;

export const usePreventAutoReloadOnNewVersion = Object.assign(
  () =>
    useSelector(
      preventAutoReloadStore,
      (s) => s.context.preventReasons.size > 0,
    ),
  {
    getState: () => ({
      addReason: (reason: string) =>
        preventAutoReloadStore.send({ type: 'addReason', reason }),
      removeReason: (reason: string) =>
        preventAutoReloadStore.send({ type: 'removeReason', reason }),
      shouldPrevent: shouldPreventAutoReload,
      preventReasons:
        preventAutoReloadStore.getSnapshot().context.preventReasons,
    }),
  },
);
